import r from "./spinners/Snake.vue.js";
import o from "./spinners/DoubleBounce.vue.js";
import t from "./spinners/TripleBounce.vue.js";
import p from "./spinners/FadingCircle.vue.js";
import { defineComponent as i } from "vue";
const n = ["Snake", "DoubleBounce", "TripleBounce", "FadingCircle"], u = function(e) {
  return {}.toString.call(e) === "[object Number]" ? (n.length <= e && (console.warn(`'${e}' spinner not found, use the default spinner.`), e = 0), n[e]) : (n.indexOf(e) === -1 && (console.warn(`'${e}' spinner not found, use the default spinner.`), e = n[0]), e);
}, a = i({
  name: "Spinner",
  components: {
    Snake: r,
    DoubleBounce: o,
    TripleBounce: t,
    FadingCircle: p
  },
  props: {
    type: { type: [Number, String], default: 0 },
    size: { type: Number, default: 0 },
    color: { type: String, default: "" }
  },
  computed: {
    spinner() {
      return `${u(this.type)}`;
    },
    spinnerColor() {
      return this.color || "#ccc";
    },
    spinnerSize() {
      return (this.size || 28) + "px";
    }
  }
});
export {
  a as default
};
